import React, { PropTypes, Component } from "react";
import styled from "styled-components";
import { NitroIcon } from "nitro-components";

const BookMarkContainer = styled.div`
	display:block;
	margin-left:${props => props.left}px;
	margin-right:${props => props.right}px;
`;

const BookMarkSection = styled.button`
	backface-visibility: hidden;
	background-color: ${props => (props.active ? "rgba(255,255,255,1)" : "rgba(255,255,255,0.2)")};
	border: 0;
	border-radius: 4px;
	box-shadow: 0 2px 4px 0 rgba(0,0,0,0.15);
	cursor: pointer;
	display:block;
	height: ${props => props.height}px;
	outline: 0;
	padding-top: ${props => (props.noTopSpace ? 0 : 2)}px;
	padding: 2px;
	position:relative;
	transform: scale(1);
	transition: transform .3s, background-color .3s;
	width: ${props => props.width}px;

	&:hover {
	  transform: scale(1.1);
		${props => !props.active && `
			background-color: rgba(255, 255, 255, 0.3);
		`};
	}

	&:focus {
		outline: 0;
	}
`;

const Bookmark = ({ active, left, right, onClick, height, width, noTopSpace, iconSize, iconLeft, variant }) => (
	<BookMarkContainer left={left} right={right}>
		<BookMarkSection
			active={active}
			onClick={onClick}
			height={height}
			width={width}
			noTopSpace={noTopSpace}
		>
			<NitroIcon
				size={iconSize}
				name={active ? "filled-bookmark" : "bookmark"}
				left={iconLeft}
				top={0}
				center
				variant={active ? variant : "white"}
			/>
		</BookMarkSection>
	</BookMarkContainer>
);

Bookmark.propTypes = {
	active: PropTypes.bool,
	left: PropTypes.number,
	right: PropTypes.number,
	iconLeft: PropTypes.number,
	onClick: PropTypes.func,
	height: PropTypes.number,
	width: PropTypes.number,
	noTopSpace: PropTypes.bool,
	iconSize:PropTypes.number,
	variant:PropTypes.string
};

Bookmark.defaultProps = {
	left: 0,
	right:0,
	height: 26,
	width: 25,
	noTopSpace: false,
	iconSize: 14,
	iconLeft: 2
};

export default Bookmark;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/Bookmark.js